export default __webpack_public_path__ + "static/media/icon-close-22x22.7be5163a.svg";